import { config } from "../../config";

export const logUpdatedState = (
  state: Object | any,
  stateKey: string | number | any,
  stateOnly: boolean = false
) => {
  if (!config.inProd) {
    if (stateOnly) {
      return console.log(`STATE UPDATE: key:${stateKey}, (new) value:`, state);
    }
    console.log(`STATE UPDATE: key:${stateKey}, (new) value:`, state[stateKey]);
  }
};

export const logIssueNetworkRequest = (methodSelector: string) => {
  if (!config.inProd) {
    console.log(`Issuing network request from: ${methodSelector}`);
  }
};

export const logIssueNetworkRequestError = (
  methodSelector: string,
  error: Error
) => {
  console.log(`${methodSelector} error:`, error);
};
